import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.5_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.5_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["FooterIconListData"] */ "/vercel/path0/src/components/common/footer/footer-icon-list-data.ts");
;
import(/* webpackMode: "eager", webpackExports: ["FooterIconList"] */ "/vercel/path0/src/components/common/footer/footer-icon-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/src/components/common/navbar/index.tsx");
